module.exports = __webpack_public_path__ + "static/media/new-background.e65608bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/new-background.png
// module id = 247
// module chunks = 1